import axios from 'axios';
import { AUTH_REQUEST, LOGIN_SUCCESS, REGISTER_SUCCESS, AUTH_FAILURE, LOGOUT, PLAY_DEMO } from '../actionTypes';
import { toast } from 'react-toastify';
import { createBrowserHistory } from 'history';
import { DEV_API } from '../../const';

const browserHistory = createBrowserHistory();

export const loginAct = (credentials) => async (dispatch) => {
  dispatch({ type: AUTH_REQUEST });
  try {
    const response = await axios.post(`${DEV_API}/api/login`, credentials);
    if (response.data.success) {
      dispatch({ type: LOGIN_SUCCESS, payload: { user: response.data.result.user, token: response.data.result.token } });
      toast(response.data.message);
    } else {
      toast(response.data.message);
    }
  } catch (error) {
    dispatch({ type: AUTH_FAILURE, payload: error.message });
  }
};

export const registerAct = (userData) => async (dispatch) => {
  dispatch({ type: AUTH_REQUEST });
  try {
    const response = await axios.post(`${DEV_API}/api/register`, userData);

    console.log(response, 'response for register')
    if (response.data.success) {
      dispatch({ type: REGISTER_SUCCESS, payload: { user: response.data.result.user, token: response.data.result.token } });
      toast(response.data.message);
    } else {
      toast(response.data.message);
    }
  } catch (error) {
    dispatch({ type: AUTH_FAILURE, payload: error.message });
    toast(error.message);
  }
};

export const verifyCodeAct = (credentials) => async (dispatch) => {
  dispatch({ type: AUTH_REQUEST });
  try {
    const response = await axios.post(`${DEV_API}/api/verifyCode`, credentials);
    if (response.data.success) {
      dispatch({ type: LOGIN_SUCCESS, payload: { user: response.data.result.user, token: response.data.result.token } });
      localStorage.setItem('token', response.data.result.token);
      localStorage.setItem('user', response.data.result.user);
      toast(response.data.message);
    } else {
      toast(response.data.message);
    }
  } catch (error) {
    dispatch({ type: AUTH_FAILURE, payload: error.message });
  }
};

export const logoutAct = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  dispatch({ type: LOGOUT });
  browserHistory.replace('/landing');
  browserHistory.go()
};

export const playDemoAct = (isDemo) => (dispatch) => {
  dispatch({ type: PLAY_DEMO, payload: isDemo });
};